@if (searchFieldsWidget) {
    <mvs-widget
            [widgetData]="searchFieldsWidget"
            (onObjectSelect)="onItemSelect($event)"
    ></mvs-widget>
}
